import BookmarksOutlinedIcon from "@mui/icons-material/BookmarksOutlined";
import DoneIcon from "@mui/icons-material/Done";
import { Chip, Tooltip, Zoom } from "@mui/material";
import { themeBBJ } from "@style/theme/material.theme";
import { ChipWrapper } from "./styles";

const renderIcon = (icon) => {
  switch (icon) {
    case "bookmarks":
      return <BookmarksOutlinedIcon sx={{ height: "20px" }} />;
    default:
      break;
  }
};
export const RenderChip = ({
  id,
  data,
  handleDelete,
  handleClick,
  color,
  selectedColor,
  showIconSelectedIcon,
  size,
  maxWidth,
  refProp,
  index,
  cropped,
  className,
  sx,
  ...props
}) => {
  return data && data.label && data.value ? (
    <ChipWrapper key={`${id}-chip-${index}`}>
      <Tooltip
        title={data.label}
        arrow
        enterDelay={200}
        disableHoverListener={!cropped}
        disableFocusListener={!cropped}
        slots={{
          transition: Zoom
        }}
      >
        <Chip
          id={`${id}-${index}`}
          icon={
            data.selected && showIconSelectedIcon && data.type !== "job" ? (
              <DoneIcon />
            ) : data.icon ? (
              renderIcon(data.icon)
            ) : undefined
          }
          label={data.label}
          value={data.value}
          type={data.type}
          ref={refProp}
          onDelete={
            handleDelete
              ? () => handleDelete(data, index)
              : data.selected && data.type === "job"
                ? () => handleClick(data, index)
                : undefined
          }
          onClick={handleClick ? () => handleClick(data, index) : undefined}
          color={data.selected ? selectedColor : color}
          size={size}
          disabled={data.disabled}
          {...props}
          {...(color === "secondary" || (data.selected && selectedColor === "secondary")
            ? {
                sx: {
                  backgroundColor: themeBBJ.palette.yellow.main,
                  "&.MuiChip-root:hover": {
                    backgroundColor: themeBBJ.palette.yellow.dark,
                  },
                  "& .MuiChip-label": {
                    color: themeBBJ.palette.primary.dark,
                  },
                  "& .MuiChip-icon": {
                    color: themeBBJ.palette.primary.dark,
                  },
                  "& .MuiChip-deleteIcon": {
                    color: themeBBJ.palette.primary.dark,
                  },
                  ...sx,
                },
              }
            : { sx })}
        />
      </Tooltip>
    </ChipWrapper>
  ) : null;
};
